import {
  API_END_POINT,
  axiosInstance,
  ENTITY_MANAGER_END_POINTS,
  validateApiParams,
} from '@app-store'
import axios, { AxiosProgressEvent } from 'axios'
import { EntitySelectRequest, FileUploadForPreSignedUrl } from '../types/common'

export const fetchPresignedURLSingleUpload = async (
  payload: FileUploadForPreSignedUrl
) => {
  return await axiosInstance.post(
    `${API_END_POINT.ENTITY_MANAGER}entities/files/generate-upload-presigned-url`,
    payload
  )
}

export const presignedURLSingleUploadPutCall = async (
  presignedUrl: string,
  selectedFile: File,
  onProgress?: (progressEvent: AxiosProgressEvent, index?: number) => void,
  index?: number,
  tagging_field?: string | undefined,
  documentIdentifierMetaData?: string | undefined
) => {
  return await axios.put(presignedUrl, selectedFile, {
    headers: {
      'Content-Type': selectedFile?.type,
      ...(tagging_field ? { 'x-amz-tagging': tagging_field } : {}),
      ...(documentIdentifierMetaData
        ? { 'x-amz-meta-DOCUMENT_IDENTIFIER': documentIdentifierMetaData }
        : {}),
    },
    onUploadProgress: (progressEvent) => {
      if (onProgress) {
        onProgress(progressEvent, index)
      }
    },
  })
}
export const fetchPresignedURLMultiUpload = async (
  payload: FileUploadForPreSignedUrl[],
  documentId: number | null
) => {
  return await axiosInstance.post(
    `${
      API_END_POINT.ENTITY_MANAGER
    }entities/files/generate-upload-presigned-url${
      documentId ? `?id=${documentId}` : ''
    }`,
    payload
  )
}

export const fetchDownloadUrlForMultipleFIles = async (
  documentId: number,
  file_name: string
) => {
  validateApiParams(
    { documentId, file_name },
    {
      endpoint: `${API_END_POINT.ENTITY_MANAGER}entities/files/bulk-download/generate-presigned-url?id=${documentId}&alias=${file_name}`,
      method: 'GET',
    }
  )
  return await axiosInstance.get(
    `${API_END_POINT.ENTITY_MANAGER}entities/files/bulk-download/generate-presigned-url?id=${documentId}&alias=${file_name}`
  )
}

export const fetchDownloadUrlForSingleFIles = async (
  rootPaths: string,
  file_name: string,
  documentId?: number | null
) => {
  const normalizedRootPath = rootPaths.endsWith('/')
    ? rootPaths
    : rootPaths + '/'

  return await axiosInstance.get(
    `${
      API_END_POINT.ENTITY_MANAGER
    }entities/files/generate-download-presigned-url?rootPath=${
      normalizedRootPath + file_name
    }&file_name=${file_name}${documentId ? `&documentId=${documentId}` : ''}`
  )
}

export const deleteFileAttachment = async (
  payload: { name: string; type: string },
  documentId: number
) => {
  return await axiosInstance.post(
    `${API_END_POINT.ENTITY_MANAGER}entities/files/remove-attachment/${documentId}`,
    payload
  )
}

export const getEntityDataForUpload = async (
  payload: EntitySelectRequest,
  recordId: number
) => {
  return await axiosInstance.post(
    `${API_END_POINT.ENTITY_MANAGER_V3}${ENTITY_MANAGER_END_POINTS.ENTITY_DATA}/get/documents/${recordId}`,
    payload
  )
}
